<div class="container">
  <div class="row">
    <div class="form-group">
      <h3>Richten Sie ein neues Gerät ein</h3>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label>
        Bitte wählen Sie einen Geräte Typ
        <select
          [(ngModel)]="method"
          [disabled]="methodLocked"
          class="form-select"
        >
          <option value="TOTP">TOTP (Authenticator App)</option>
        </select>
      </label>
    </div>
  </div>
  <div class="row">
    <div class="form-group">
      <label class="small">
        Derzeit unterstützen wir die Zwei-Faktor-Authentifizierung durch eine
        E-Mail TAN oder Authenticator App. In Zukunft werden weitere Methoden
        hinzugefügt.
      </label>
    </div>
  </div>
  <hr/>
  <ng-container *ngIf="method === 'TOTP'">
    <div class="row">
      <div class="form-group">
        <p>
          Einrichtungshinweise für TOTP Geräte wie die Authenticator App finden
          Sie
          <a
            href="https://www.sanakey.de/sanakey-portal/google-authenticator/"
            tabindex="-1"
            target="_blank"
          >hier</a
          >.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <label>
          Zur Einrichtung ist Eingabe Ihres Passworts erforderlich
          <input
            (keyup.enter)="requestNewDevice()"
            [(ngModel)]="password"
            [disabled]="setupResponse"
            class="form-control"
            placeholder="Ihr aktuelles Passwort"
            type="password"
          />
        </label>
        <san-form-input-error
          [visible]="!password"
          message="Das Passwort ist erforderlich"
        ></san-form-input-error>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <button
          (click)="requestNewDevice()"
          [disabled]="!password || setupResponse || transmitting"
          class="btn btn-primary"
        >
          <span *ngIf="setupResponse"
          >QR Code und Schlüssel wurden generiert</span
          >
          <span *ngIf="!setupResponse">QR Code und Schlüssel generieren</span>
          <span *ngIf="!setupResponse && transmitting">
            &nbsp;
            <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon
            ></span>
        </button>
      </div>
    </div>
    <ng-container *ngIf="setupResponse">
      <div class="row">
        <div class="form-group">
          <label> Ihr QR Code für die Authenticator App: </label>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="form-group">
          <img
            [alt]="setupResponse.alt_code"
            [src]="setupResponse.qrcode"
            class="img-thumbnail"
            height="auto"
            width="200"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <label> Ihr Schlüssel für die Einrichtung ohne QR Code: </label>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="form-group text-center">
          <span *ngIf="setupResponse._showKey">{{
              setupResponse.alt_code
            }}</span
          ><br/>
          <a
            (click)="setupResponse._showKey = true"
            *ngIf="!setupResponse._showKey"
            href="javascript:void(0)"
          >
            Schlüssel anzeigen
          </a>
          <a
            (click)="setupResponse._showKey = false"
            *ngIf="setupResponse._showKey"
            href="javascript:void(0)"
          >
            Schlüssel verbergen
          </a>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <label>
            Bestätigen Sie das neue Gerät, indem Sie die angezeigte TAN (sechs
            Ziffern) eingeben:
            <input
              [(ngModel)]="verificationPin"
              class="form-control"
              maxlength="6"
              minlength="6"
              type="text"
            />
          </label>
          <san-form-input-error
            [visible]="verificationPinInvalid"
            message="Die TAN ist ungültig"
          ></san-form-input-error>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <label>
            Sie können Ihr Gerät benennen, um es besser identifizieren zu können
            (ansonsten wird es "{{ defaultDeviceName }}" benannt):
            <input
              [(ngModel)]="deviceName"
              [placeholder]="defaultDeviceName"
              class="form-control"
              type="text"
            />
          </label>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <button
            (click)="verifyDevice()"
            [disabled]="!verificationPin || transmitting"
            class="btn btn-primary"
          >
            Gerät aktivieren und speichern
            <span *ngIf="setupResponse && transmitting">
              &nbsp;
              <fa-icon [icon]="loadingIcon" animation="spin-pulse"></fa-icon
              ></span>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div class="row">
    <div class="form-group">
      <san-form-input-error
        [message]="errorMessage"
        [visible]="errorMessage"
      ></san-form-input-error>
    </div>
  </div>
</div>
